import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const name = 'NetworkDownSpinner';

interface Props {
    open: boolean;
}

const NetworkDownSpinner: React.FC<Props> = ({ open }) => (
    <Backdrop
        sx={{ color: '#fff', backgroundColor: "rgb(0 0 0 / 83%)", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
    >
        <CircularProgress color="inherit" />
        <Typography variant="h6" color="inherit" sx={{ ml: 2 }}>
            Network is down waiting for connection...
        </Typography>
    </Backdrop>
);

NetworkDownSpinner.displayName = name;

export default NetworkDownSpinner;